<script setup lang="ts">
const swUpdating = useState('swUpdating', () => false);
const dialogRef = useTemplateRef('swUpdateDialog');

watch(swUpdating, (val) => {
  if (val) dialogRef.value?.showModal();
});
</script>

<template>
  <UApp :toaster="{ position: 'top-right', ui: { viewport: 'toast-viewport' } }">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <NativeAppUpdateNotice />
  </UApp>
  <dialog
    ref="swUpdateDialog"
    class="m-0 p-0 border-0 bg-transparent w-screen max-w-none h-dvh max-h-none backdrop:bg-black/60 backdrop:backdrop-blur-sm"
  >
    <div class="flex flex-col items-center justify-center w-full h-full gap-4">
      <UIcon name="heroicons:arrow-path" class="text-white text-5xl animate-spin" />
      <p class="text-white text-lg font-medium">{{ $t('pwa.updating') }}</p>
    </div>
  </dialog>
</template>

<style>
.toast-viewport {
  top: max(1rem, env(safe-area-inset-top)) !important;
}

.page-enter-active,
.page-leave-active {
  transition: all 0.3s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>
